import { PaneArea } from '../../types/shared'
import Triangle, { ITriangleAttrs } from '../canvas/triangle'
import PaneModel from '../models/pane'

type Area = PaneArea
type Attrs = ITriangleAttrs
type PartialAttrs = Partial<Attrs>

class TriangleCreator extends Triangle<Attrs> {
  isCreator = true
  mouseDowns = 1

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    this.attrs.x1 = startArea.x
    this.attrs.y1 = startArea.y
    this.toolsCallback = toolsCallback

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  onMouseDown() {
    this.mouseDowns++
    if (this.mouseDowns === 3) {
      this.release()
      this.replaceMyself(Triangle.fromObject<Triangle>(this.attrs, this.model))
      this.toolsCallback()
    }
  }

  onMouseMove(area: Area) {
    switch (this.mouseDowns) {
      case 1:
        this.attrs.x2 = area.x
        this.attrs.y2 = area.y
        break
      case 2:
        this.attrs.x3 = area.x
        this.attrs.y3 = area.y
        break
      default:
        break
    }
    this.trigger('change')
  }
}

export default TriangleCreator
